export type EnvironmentName = "production" | "preview" | "development";

/** Hosts que servem o site de verdade, para gente de verdade. */
const PRODUCTION_HOSTS = new Set(["www.tamiapp.com", "tamiapp.com"]);

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0", "[::1]"]);

/**
 * Nome do ambiente carimbado em todo evento do PostHog.
 *
 * O critério é o hostname, e não `NEXT_PUBLIC_VERCEL_ENV`, porque essa variável
 * está fixada em `prod` na `.env` committada — ela vale igual na máquina do dev
 * e em produção, então classificaria as duas do mesmo jeito. Com 38 usuários
 * ativos por mês, uma tarde de testes local carimbada como produção distorceria
 * o funil inteiro.
 */
export const resolveEnvironmentName = (hostname: string): EnvironmentName => {
  const host = hostname.trim().toLowerCase().replace(/:\d+$/, "");

  if (LOCAL_HOSTS.has(host) || host.endsWith(".local")) return "development";
  if (PRODUCTION_HOSTS.has(host)) return "production";

  // Preview da Vercel, stage, domínio de teste: existe, mas não é produção.
  return "preview";
};
